<template>
  <div v-if="filterLoaded && filterSettingsLoaded">
    <div class="Agendafilter margin20bottom">
      <div class="row resetFilter">
        <div class="col-md-12 form-group rowResetFilterWrapper">
          <a href="#" @click="lblreset()">{{ translation(3346) }}</a>
        </div>
      </div>
      <!-- startdatum -->
      <div class="row" id="lblStartDate">
        <div class="col-12">
          <label>{{ translation(16702) }}</label>
        </div>
      </div>
      <div class="row" id="rowStartDate">
        <div class="col-12 form-group has-feedback" v-bind:class="{ 'form-group--error': errors.has('tbxStartDate') }">
          <XVdate
            key="tbxStartDate"
            id="tbxStartDate"
            name="tbxStartDate"
            v-model.trim="filterinputdata.tbxStartDate"
            :data-vv-as="translation(56)"
            v-validate="{ XVDateDefault: true }"
            @input="inputStartDate()"
          ></XVdate>
          <span style="color: red">{{ errors.first('tbxStartDate') }}</span>
        </div>
      </div>
      <!-- courseType -->
      <div class="row" id="rowCourseType" v-if="filterdata.courseTypes.length !== 0">
        <div class="col-12 form-group">
          <XVradiobuttonlist
            id="courseType"
            :datalist="filterdata.courseTypes"
            v-model="filterinputdata.cbCourseType"
            :radiobuttonsright="true"
            @input="setCourseTypesFilter"
          ></XVradiobuttonlist>
        </div>
      </div>
      <hr class="mt-2 mb-3 margin20bottom" />
      <!-- taal -->
      <div class="row" id="lblTaalkeuze" v-if="languages.length !== 0">
        <div class="col-12">
          <label>{{ translation(8444) }}</label>
        </div>
      </div>
      <div class="row" id="rowddlTaalkeuze" v-if="languages.length !== 0">
        <div class="col-12 form-group">
          <XVdropdown
            id="ddlTaalkeuze"
            name="ddlTaalkeuze"
            :placeholder="translation(18921)"
            :datalist="languages"
            v-model="filterinputdata.selectedLanguage"
            @input="setSelectedLanguage"
          ></XVdropdown>
        </div>
      </div>
      <!-- competenties -->
      <div class="row" id="lblCompetence" v-if="competences.length !== 0">
        <div class="col-12">
          <label>{{ translation(13459) }}</label>
        </div>
      </div>
      <div class="row" id="rowddlCompetence" v-if="competences.length !== 0">
        <div class="col-12 form-group">
          <XVdropdown
            id="ddlCompetence"
            name="ddlCompetence"
            :placeholder="translation(18922)"
            :datalist="competences"
            v-model="filterinputdata.selectedCompetence"
            @input="setSelectedCompetence"
          ></XVdropdown>
        </div>
      </div>
      <!-- competentieslider -->
      <div
        class="row"
        id="lblCompetenceSlider"
        v-if="competences.length !== 0 && filterinputdata.selectedCompetence !== ''"
      >
        <div class="col-12">
          <label>{{ translation(18162) }}</label>
        </div>
      </div>
      <div
        class="row margin20bottom"
        id="rowCompetenceSlider"
        v-if="competences.length !== 0 && filterinputdata.selectedCompetence !== ''"
      >
        <div class="col-12">
          <vue-slider
            name="sliderCompentence"
            id="sliderCompentence"
            @change="setStarRatingEducation"
            v-model="filterinputdata.selectedCompetencePercentage"
            :min="0"
            :max="100"
            :marks="false"
            :adsorb="false"
            :duration="0.2"
            :lazy="true"
            :contained="true"
            :hide-label="true"
            :tooltip-formatter="'{value}%'"
          ></vue-slider>
        </div>
      </div>
      <hr
        class="mt-2 mb-3 marg in20bottom"
        v-if="competences.length !== 0 && filterinputdata.selectedCompetence !== ''"
      />
      <!-- categories -->
      <div class="row" id="lblCategory" v-if="categories.length > 0">
        <div class="col-12">
          <label>{{ translation(812) }}</label>
        </div>
      </div>
      <div class="row" id="rowddlCategory" v-if="categories.length > 0">
        <div class="col-12 form-group">
          <XVdropdown
            id="ddlCategories"
            name="ddlCategories"
            :placeholder="translation(18923)"
            :datalist="categories"
            v-model="filterinputdata.selectedCategory"
            @input="setSelectedCategory"
          ></XVdropdown>
        </div>
      </div>
      <!-- CourseTree header -->
      <div class="coursetree">
        <div
          class="row pointer headerCourseTreeRow"
          @click="headertoggle()"
          v-if="filtersettings.showCourseTreeHeader && filterdata.courseTree[0].length > 1"
        >
          <div class="col-12">
            <span>
              <label v-html="filtersettings.courseTreeHeader"></label>
              <font-awesome-icon v-if="!filtersettings.courseTreeDropdown" icon="chevron-down" class="pull-right" />
              <font-awesome-icon v-if="filtersettings.courseTreeDropdown" icon="chevron-up" class="pull-right" />
            </span>
          </div>
        </div>

        <!-- coursetree -->
        <!-- 5 scenario's:
            0) als main.length = 1, dan header weglaten issue 29548
            1) als main.length === 1, sub1 > 1, dan uitklapbaar houden
            2) als main.length > 1, sub1 > 1, dan uitklapbaar houden
            3) als tree === 1, als main.length === 1, sub === 1, dan geen main, geen sub, maar meteen radiobuttons
            3a)als tree > 1--, als main.length === 1, sub === 1, dan wel- main, geen sub, maar meteen radiobuttons (net als 4)
            4) --------------, als main.length > 1, sub === 1, dan na main geen sub maar meteen radiobuttons-->
        <div v-for="(tree, index) in filterdata.courseTree" :key="index + 'tree'">
          <div class="row" id="rowCoursetree" v-if="tree.length !== 0">
            <div class="col-12">
              <!-- CourseTree main -->
              <!-- 3) als main.length === 1, sub === 1, dan geen main, geen sub, maar meteen radiobuttons -->
              <div
                v-if="tree.length === 1 && tree[0].subLevels.length === 1 && filterdata.courseTree.length === 1"
                class="subSubCourseTreeRow"
              >
                <div class="row subSubCourseTreeNoMain">
                  <div class="col-12">
                    <label v-html="filtersettings.courseTreeHeader"></label>
                  </div>
                </div>
                <div class="row subSubCourseTreeNoMain" id="rowddlCourseTree">
                  <div class="col-12 form-group">
                    <XVdropdown
                      id="ddlCourseTree"
                      name="ddlCourseTree"
                      :placeholder="translation(18924)"
                      :datalist="filtersettings.courseTreeSubSubItems"
                      v-model="filterinputdata.cbSubSubCourseTreeDropdown"
                      @input="setSubSubCourseTree"
                    ></XVdropdown>
                  </div>
                </div>
              </div>
              <div v-if="filtersettings.courseTreeDropdown === true">
                <div
                  v-if="
                    tree.length > 1 ||
                    (tree.length === 1 && tree[0].subLevels.length > 1) ||
                    filterdata.courseTree.length > 1
                  "
                >
                  <div class="row pointer mainCourseTreeRow" v-for="(sub, index) in tree" :key="index">
                    <div class="col-12 form-group">
                      <span @click="maintoggle(sub.id)" class="mainCourseTree" :class="coursetreebold">
                        {{ sub.name }}
                        <font-awesome-icon v-if="!sub.mainRowToggle" icon="chevron-down" class="pull-right" />
                        <font-awesome-icon v-if="sub.mainRowToggle" icon="chevron-up" class="pull-right" />
                      </span>
                      <div v-if="sub.mainRowToggle === true">
                        <!-- 3a) als tree > 1, als main.length === 1, sub === 1, dan wel- main, geen sub, maar meteen radiobuttons (net als 4) -->
                        <!-- 4) als main.length > 1, sub === 1, dan na main geen sub maar meteen radiobuttons-->
                        <div v-if="sub.subLevels.length === 1">
                          <div
                            class="row subSubCourseTreeRow"
                            v-for="(sub2, index) in sub.subLevels[0].subSubLevels"
                            :key="index"
                          >
                            <div class="col-12 form-group">
                              <span class="subSubCourseTree">
                                {{ sub2.name }}
                                <label class="input-radio pointer pull-right">
                                  <input
                                    type="radio"
                                    v-model="filterinputdata.cbSubSubCourseTree"
                                    :value="sub2.id"
                                    name="subsub"
                                    :id="'coursetree_' + sub2.id"
                                    @change="setSubSubCourseTree"
                                  />
                                  <span></span>
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-if="sub.subLevels.length > 1">
                          <!-- 1) als main.length === 1, sub1 > 1, dan uitklapbaar houden -->
                          <!-- 2) als main.length > 1, sub1 > 1, dan uitklapbaar houden -->
                          <div class="row pointer subCourseTreeRow" v-for="(sub1, index) in sub.subLevels" :key="index">
                            <div class="col-12">
                              <a :id="'lblSub' + sub1.id" href="javascript:void(0)"
                                ><span @click="subtoggle(sub1.id)" class="subCourseTree">
                                  {{ sub1.name }}
                                </span></a
                              >
                              <!-- CourseTree subsub -->
                              <div v-if="sub1.subRowToggle === true">
                                <div
                                  class="row subSubCourseTreeRow"
                                  v-for="(sub2, index) in sub1.subSubLevels"
                                  :key="index"
                                >
                                  <div class="col-12 form-group">
                                    <span class="subSubCourseTree">
                                      {{ sub2.name }}
                                      <label class="input-radio pointer pull-right">
                                        <input
                                          type="radio"
                                          v-model="filterinputdata.cbSubSubCourseTree"
                                          :value="sub2.id"
                                          name="subsub"
                                          :id="'coursetree_' + sub2.id"
                                          @change="setSubSubCourseTree"
                                        />
                                        <span></span>
                                      </label>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- course naam/id input -->
      <div class="row" id="lblCoursenameid">
        <div class="col-12">
          <label>{{ translation(16704) }}</label>
        </div>
      </div>
      <div class="row" id="rowTbxCourseNameId">
        <div class="col-12 form-group">
          <XVinput
            id="tbxCourseNameId"
            name="tbxCourseNameId"
            :placeholder="translation(18925)"
            v-model="filterinputdata.tbxCourseNameId"
            type="text"
            @changeValOnInput="setSelectedCourseId"
          ></XVinput>
        </div>
      </div>
      <!-- course instituut input -->
      <div class="row" id="lbloplinstituut">
        <div class="col-12">
          <label>{{ translation(95) }}</label>
        </div>
      </div>
      <div class="row" id="rowTbxInstitute">
        <div class="col-12 form-group">
          <XVinput
            id="TbxInstitute"
            name="TbxInstitute"
            :placeholder="translation(18926)"
            v-model="filterinputdata.tbxInstitute"
            type="text"
            @changeValOnInput="setSelectedInstitute"
          ></XVinput>
        </div>
      </div>
      <!-- instellingsaccreditatie -->
      <div class="row" id="instellingsAccr" v-if="filtersettings.hasAccreditation">
        <div class="col-12">
          <span>{{ translation(6875) }}</span>
          <div class="pull-right">
            <XVcheckbox
              @click="toggleInstellingsAccr()"
              v-model="filterinputdata.cbInstellingsAccr"
              id="cbSelectAll"
              @input="setInstellingsAccr"
            ></XVcheckbox>
          </div>
        </div>
      </div>
      <!-- clusters -->
      <div class="row" id="rowClusters" v-if="clusters.length > 0 && !hideClusterChoice">
        <div class="col-12 form-group">
          <XVcheckboxlist
            id="cbclusters"
            :datalist="clusters"
            v-model="filterinputdata.cbclusters"
            :checkboxesright="true"
            @input="setSelectedClusters"
          ></XVcheckboxlist>
        </div>
      </div>
      <!-- locations -->
      <div class="row" id="lblLocatie" v-if="filterinputdata.cbCourseType === 1">
        <div class="col-12">
          <label>{{ translation(16705) }}</label>
        </div>
      </div>
      <div class="row" id="rowLocatie" v-if="filterinputdata.cbCourseType === 1">
        <div class="col-12">
          <XVinput
            id="tbxLocatie"
            name="tbxLocatie"
            :placeholder="translation(18927)"
            v-model="filterinputdata.tbxLocatie"
            type="text"
            @changeValOnInput="setSelectedLocation"
          ></XVinput>
          {{ translation(16706) }} {{ filterinputdata.locatieRange }} {{ translation(16707) }}
        </div>
      </div>
      <div
        class="row"
        id="rowLocatieRange"
        v-if="filtersettings.locationmarks.length !== 0 && filterinputdata.cbCourseType === 1"
      >
        <div class="col-12">
          <div class="sliderpadding">
            <vue-slider
              name="locatieRange"
              id="locatieRange"
              v-model="filterinputdata.locatieRange"
              :data="filtersettings.locationmarks"
              :min="0"
              :max="20000"
              :marks="true"
              :adsorb="true"
              :duration="0.2"
              :contained="true"
              :hide-label="true"
              @drag-end="getLocation"
              :disabled="filterinputdata.tbxLocatie === ''"
            ></vue-slider>
          </div>
        </div>
      </div>
      <!-- points -->
      <div class="row" id="lblSlPoints" v-if="filtersettings.maxPoints !== 0">
        <div class="col-12">
          <label>{{ translation(16765) }}</label>
        </div>
      </div>
      <div class="row" id="rowSlPoints" v-if="filtersettings.maxPoints !== 0">
        <div class="col-12 form-group">
          <!-- bevat het maximum aantal punten van de puntenslider, min is altijd 0. -->
          <div class="sliderpadding">
            <vue-slider
              name="slCategoryPoints"
              id="slCategoryPoints"
              v-model="filterinputdata.categoryPoints"
              @change="setSelectedCategoryPoints"
              :min="0"
              :max="filtersettings.maxPoints"
              :duration="0.2"
              :lazy="true"
              :contained="true"
              :marks="filtersettings.maxPointsMarks"
            ></vue-slider>
          </div>
        </div>
      </div>
      <!-- sterren rating course-->
      <div class="row margin10" id="rowLblStarRatingCourse" v-if="filtersettings.hasRatings">
        <div class="col-12">
          <label id="lblStarRatingCourse">{{ translation(16766) }}</label>
        </div>
      </div>
      <div class="row" id="rowStarRatingCourse" v-if="filtersettings.hasRatings">
        <div class="col-12">
          <div class="star-ratings-css pull-right">
            <div class="star-ratings-css-top" :style="{ width: filterinputdata.selectedCourseRating * 20 + '%' }">
              <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </div>
            <div class="star-ratings-css-bottom">
              <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        id="rowStarRatingCourseSlider"
        v-if="filtersettings.hasRatings && filterinputdata.selectedCourseRating >= 1"
      >
        <div class="col-md-12 form-group">
          <vue-slider
            name="sliderRating"
            id="sliderRating"
            @change="setStarRatingCourse"
            v-model="filterinputdata.selectedCourseRating"
            :min="1"
            :max="5"
            :marks="true"
            :adsorb="true"
            :duration="0.2"
            :contained="true"
            :hide-label="true"
          ></vue-slider>
        </div>
      </div>
      <!-- sterren rating Education-->
      <div class="row margin10" id="rowLblStarRatingEducation" v-if="filtersettings.hasRatings">
        <div class="col-12">
          <label id="lblStarRating">{{ translation(16767) }}</label>
        </div>
      </div>
      <div class="row" id="rowStarRatingEducation" v-if="filtersettings.hasRatings">
        <div class="col-12">
          <div class="star-ratings-css pull-right">
            <div class="star-ratings-css-top" :style="{ width: filterinputdata.selectedEducationRating * 20 + '%' }">
              <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </div>
            <div class="star-ratings-css-bottom">
              <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="filtersettings.hasRatings && filterinputdata.selectedEducationRating >= 1">
        <div class="col-md-12 form-group">
          <vue-slider
            name="sliderRating"
            id="sliderRating"
            @change="setStarRatingEducation"
            v-model="filterinputdata.selectedEducationRating"
            :min="1"
            :max="5"
            :marks="true"
            :adsorb="true"
            :duration="0.2"
            :contained="true"
            :hide-label="true"
          ></vue-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import VueSlider from 'vue-slider-component'

export default {
  mixins: [FAMixin],
  components: { VueSlider },
  data: function () {
    return {
      debounce: null,
    }
  },
  async mounted() {
    this.setprofgroupid(parseInt(this.$route.params.profgroup, 10))
    if (this.$route.params.langid) {
      this.getChangeLanguage(this.$route.params.langid)
    }
    await this.getTexten()
    if (!this.filterLoaded) {
      await this.getFilters()
      await this.getFilterSettings()
    }
    await this.getStickyHeight()
    await this.getParametersFromUrl()
  },
  computed: {
    filterinputdata: sync('Agenda/filterinputdata'),
    ...mapGetters('Agenda', [
      'filterdata',
      'filtersettings',
      'competences',
      'categories',
      'clusters',
      'languages',
      'filterLoaded',
      'filterSettingsLoaded',
      'hideClusterChoice',
    ]),
    coursetreebold() {
      return this.filtersettings.courseTreeDropdown && this.filterdata.courseTree[0].length === 1 ? 'bold' : ''
    },
  },
  watch: {
    filterSettingsLoaded(loaded) {
      if (loaded) {
        this.getTableData()
      }
    },
  },
  methods: {
    ...mapMutations(['addNotification']),
    ...mapActions('Agenda', [
      'getChangeLanguage',
      'getTexten',
      'getFilters',
      'getFilterSettings',
      'filterClick',
      'getTableData',
      'getLocation',
      'getStickyHeight',
      'getParametersFromUrl',
      'getFilterValuesFromLocalStorage',
      'getLblReset',
    ]),
    ...mapMutations('Agenda', [
      'setprofgroupid',
      'setMoreOptions',
      'setCourseTreeMainVisible',
      'setCourseTreeSubVisible',
      'setCourseTreeSubSubVisible',
      'setStickyHeight',
    ]),
    toggleInstellingsAccr() {},
    headertoggle() {
      this.setCourseTreeMainVisible()
    },
    maintoggle(id) {
      this.setCourseTreeSubVisible(id)
    },
    subtoggle(id) {
      this.setCourseTreeSubSubVisible(id)
    },
    inputStartDate() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.filterClick()
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    setCourseTypesFilter() {
      this.filterClick()
    },
    setSelectedCompetence() {
      this.filterClick()
    },
    setSelectedCategory() {
      this.filterClick()
    },
    setSubSubCourseTree() {
      this.filterClick()
    },
    setSelectedInstitute() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.filterClick()
      }, 600)
    },
    setSelectedCourseId() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.filterClick()
      }, 600)
    },
    setInstellingsAccr() {
      this.filterClick()
    },
    setSelectedClusters() {
      this.filterClick()
    },
    setSelectedLocation() {
      // if (this.filterinputdata.locatieRange < 20000) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.getLocation()
      }, 600)
      // }
    },
    setSelectedCategoryPoints() {
      this.filterClick()
    },
    setStarRatingCourse() {
      this.filterClick()
    },
    setStarRatingEducation() {
      this.filterClick()
    },
    setSelectedLanguage() {
      this.filterClick()
    },
    lblreset() {
      this.getLblReset()
    },
  },
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: 600;
}
.resetFilter {
  text-align: center;
  .rowResetFilterWrapper {
    justify-content: center;
  }
}
.subCourseTreeRow a,
.subSubCourseTree {
  font-size: 12px;
}
.subSubCourseTree {
  margin-left: 10px;
}
.subCourseTreeRow {
  margin-top: 5px;
  margin-bottom: 5px;
}
.fa-chevron-down,
.fa-chevron-up {
  position: absolute;
  top: 0px;
  right: 15px;
}
#moreOptions,
#lblrating {
  float: left;
}
#rowStarRating .star-ratings-css {
  margin-left: auto;
}
</style>
<style>
.bodyPublic .resetxvdate {
  display: none;
}
.bodyPublic .sliderpadding {
  padding-bottom: 20px;
  padding-top: 15px;
}
.bodyPublic .ie11gridhack {
  display: inline;
  margin: 0 1px 0 1px;
  font-size: 6px;
}
.bodyPublic .fa-star {
  color: #ccc;
}
.bodyPublic .squaredFour {
  margin: 0;
}
</style>
